import { memo, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Col, Row } from 'reactstrap';

import { Card } from 'Elements';

import styles from 'partials/card/subscription-card.module.scss';
import { clx, formatLocalAddress, getCurrentLocale } from 'src/helpers/Utils';
import { usePartnerDetails } from 'src/hooks/useCommunityPartner';
import { useParams } from 'react-router-dom';

export const DetailPartnerGeneral: FC = memo(() => {
	const { t } = useTranslation();
	const { partner_id } = useParams();

	const { data: fields } = usePartnerDetails(partner_id as string);

	const getTitleSector = (element) => {
		if (!element) return '';
		const locale = getCurrentLocale().code.toLowerCase();
		const found = element.translateTitles?.find(
			(item) => item?.language?.toLowerCase() === locale
		);
		return (
			found?.value ||
			element?.translateTitles?.[0]?.value ||
			element?.title ||
			''
		);
	};

	return (
		<Card className="h-100">
			<Row>
				<Col
					md={8}
					xxl={6}
					style={{
						borderRight: '1px solid #EEEFF3'
					}}>
					<div
						className={clx(
							styles.row,
							'd-flex align-items-center justify-content-between'
						)}
						style={{
							borderBottom: '1px solid #EEEFF3',
							padding: '8px 0'
						}}>
						<span
							className={clx(
								'fs-sm lh-base fw-500',
								styles.rowLabel
							)}>
							{t('forms.slogan')}
						</span>
						<span className="fs-sm lh-base fw-400">
							{fields?.slogan}
						</span>
					</div>
					<div
						className={clx(
							styles.row,
							'd-flex align-items-center justify-content-between'
						)}
						style={{
							borderBottom: '1px solid #EEEFF3',
							padding: '8px 0'
						}}>
						<span
							className={clx(
								'fs-sm lh-base fw-500',
								styles.rowLabel
							)}>
							{t('forms.sector')}
						</span>
						<span className="fs-sm lh-base fw-400">
							{getTitleSector(fields?.businessSectorInfo)}
						</span>
					</div>
					<div
						className={clx(
							styles.row,
							'd-flex align-items-center justify-content-between'
						)}
						style={{
							borderBottom: '1px solid #EEEFF3',
							padding: '8px 0'
						}}>
						<span
							className={clx(
								'fs-sm lh-base fw-500',
								styles.rowLabel
							)}>
							{t('forms.tax-number')}
						</span>
						<span className="fs-sm lh-base fw-400">
							{fields?.taxNumber}
						</span>
					</div>
					<div className="d-flex flex-column gap-2">
						<span
							className={clx(
								'fs-sm lh-base fw-500',
								styles.rowLabel
							)}>
							{t('forms.short-desc')}
						</span>
						<span className="fs-sm lh-base fw-400">
							{fields?.description}
						</span>
					</div>
				</Col>
				<Col md={8} xxl={6}>
					<div
						className={clx(
							styles.row,
							'd-flex align-items-center justify-content-between'
						)}
						style={{
							borderBottom: '1px solid #EEEFF3',
							padding: '8px 0'
						}}>
						<span
							className={clx(
								'fs-sm lh-base fw-500',
								styles.rowLabel
							)}>
							{t('forms.website')}
						</span>
						<span className="fs-sm lh-base fw-400">
							{fields?.webSiteAddress}
						</span>
					</div>
					<div
						className={clx(
							styles.row,
							'd-flex align-items-center justify-content-between'
						)}
						style={{
							borderBottom: '1px solid #EEEFF3',
							padding: '8px 0'
						}}>
						<span
							className={clx(
								'fs-sm lh-base fw-500',
								styles.rowLabel
							)}>
							{t('forms.email')}
						</span>
						<span className="fs-sm lh-base fw-400">
							{fields?.mainEmailAddress}
						</span>
					</div>
					<div
						className={clx(
							styles.row,
							'd-flex align-items-center justify-content-between'
						)}
						style={{
							borderBottom: '1px solid #EEEFF3',
							padding: '8px 0'
						}}>
						<span
							className={clx(
								'fs-sm lh-base fw-500',
								styles.rowLabel
							)}>
							{t('forms.hr-email-address')}
						</span>
						<span className="fs-sm lh-base fw-400">
							{fields?.hrEmailAddress}
						</span>
					</div>
					<div className="d-flex flex-column gap-2">
						<span
							className={clx(
								'fs-sm lh-base fw-500',
								styles.rowLabel
							)}>
							{t('forms.address')}
						</span>
						<span className="fs-sm lh-base fw-400">
							{fields?.address &&
								formatLocalAddress(
									fields?.address?.street,
									fields?.address?.houseNumber,
									fields?.address?.postalCode,
									fields?.address?.city,
									fields?.address?.state
								)}
						</span>
					</div>
				</Col>
			</Row>
		</Card>
	);
});

DetailPartnerGeneral.displayName = 'DetailPartnerGeneral';
